import mixpanel from 'mixpanel-browser';

export enum MEvents {
  PageViewed = 'me-lemon_page_view',
  WelcomePageViewed = 'me-lemon_welcome_page_viewed',
  EducationAdded = 'me-lemon_education_added',
  ProjectAdded = 'me-lemon_contact_project_added',
  ProjectEdited = 'me-lemon_contact_project_updated',
  ExperienceInfoSubmitted = 'me-lemon_experience_info_submitted',
  ProfileInfoSubmitted = 'me-lemon_profile_info_submitted',
  ProfileViewed = 'me-lemon_profile_viewed',
  ProfileTechStackViewed = 'me-lemon_profile_techstack_viewed',
  ProfileCvSamplesViewed = 'me-lemon_profile_cv_samples_viewed',
  ProfilePreferencesViewed = 'me-lemon_profile_preferences_viewed',
  ProfileContactsViewed = 'me-lemon_profile_contacts_viewed',
  ProfileSettingsViewed = 'me-lemon_profile_settings_viewed',
  FieldUpdated = 'me-lemon_field_update',
  SessionEnd = 'me-lemon_session_end',
  SessionStart = 'me-lemon_session_start',
  ContactAvailabilityHoursUpdated = 'me-lemon_contact_availability_hours_updated',
}

export const fieldUpdatedMEvent = (
  field_name: string,
  field_previous_value: unknown,
  field_updated_value: unknown
) => {
  mixpanel.track(MEvents.FieldUpdated, {
    field_name,
    field_previous_value,
    field_updated_value,
  });
};

export const PageViewedMEvent = (path: string) => {
  const pageName = ((path.split('/')[1].match(/^[a-z0-9-]+/gi) || [])[0] || '')
    .toLowerCase()
    .replaceAll('-', '_');

  if (pageName) {
    mixpanel.track(MEvents.PageViewed, {
      page_name: pageName,
    });
  }
};
